import { keepAliveService } from './KeppAliveService';
import * as Network from './network';
import { router } from '../router/Router';
import { createFabric } from './core/fabricCore';

const _fabric = createFabric({
    httpClient: Network,
    urlPrefix: () => router.appPrefix,
    onActivity: () => keepAliveService.restart(),
});

export const invokeCommands = _fabric.invokeCommands;
export const invokeWS = _fabric.invokeWS;
